import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import AddMeetingModal from './AddMeetingModal';
import DropdownFilter from 'components/common/DropdownFilter';
import AppContext from 'context/Context';
import EditMeetingModal from './EditMeetingModal';
// import RecurrenceModal from './RecurrenceModal';
import { RRule } from 'rrule';
import { parseSourceToRuleParam, localToUTC } from 'helpers/rRuleHelper';

import {
  patchMeeting,
  searchMeetings
} from 'services/customer-service/scMeetingService';
import moment from 'moment';

const createRecurringEvents = event => {
  if (!event || !event.repeatRule) {
    return [event];
  }

  const rParam = parseSourceToRuleParam(event.repeatRule);

  const rule = RRule.fromString(new RRule(rParam).toString());
  const dates = rule.all().map(localToUTC);

  const result = dates.map(date => {
    const startDate = date;
    const endDate = moment(date)
      .add(
        moment(event.end_date).diff(moment(event.start_date), 'milliseconds'),
        'milliseconds'
      )
      .toDate();

    return {
      ...event,
      originalStart: event.start,
      originalEnd: event.end,
      start: startDate,
      end: endDate
    };
  });
  return result;
};

const Calendar = () => {
  const {
    config: { isRTL }
  } = useContext(AppContext);
  const calendarRef = useRef();
  const [title, setTitle] = useState('');
  const [calendarApi, setCalendarApi] = useState({});
  const [currentFilter, setCurrentFilter] = useState('Week View');
  const [isOpenScheduleModal, setIsOpenScheduleModal] = useState(false);
  const [isOpenEventModal, setIsOpenEventModal] = useState(false);
  const [modalEventContent, setModalEventContent] = useState({});
  const [scheduleStartDate, setScheduleStartDate] = useState();
  const [scheduleEndDate, setScheduleEndDate] = useState();

  const [meetings, setMeetings] = useState([]);
  const fetchData = async () => {
    let rs = await searchMeetings();
    const localEvents = rs;

    // let meetings = [];
    // localEvents.map(i => {
    //   const recurringMeetings = createRecurringEvents(i);
    //   meetings.push(...recurringMeetings);
    // });

    // const finalMeetings = meetings.map(i => {
    //   const localStart = moment
    //     .utc(i.start)
    //     .local()
    //     .format('YYYY-MM-DD HH:mm:ss');
    //   const localEnd = moment.utc(i.end).local().format('YYYY-MM-DD HH:mm:ss');
    //   return { ...i, start: localStart, end: localEnd };
    // });

    // Sử dụng hàm createRecurringEvents
    let meetings = [];
    localEvents.forEach(event => {
      const recurringMeetings = createRecurringEvents(event);
      meetings.push(...recurringMeetings);
    });

    // Chuyển đổi địa phương và định dạng lại ngày giờ

    const finalMeetings = meetings.map(event => ({
      ...event,
      start: moment.utc(event.start).local().format('YYYY-MM-DD HH:mm:ss'),
      end: moment.utc(event.end).local().format('YYYY-MM-DD HH:mm:ss')
    }));

    // console.log(finalMeetings);
    setMeetings(finalMeetings);
  };
  useEffect(() => {
    fetchData();

    const storedValue = localStorage.getItem('isOpenScheduleModal');
    if (storedValue === 'true') {
      setIsOpenScheduleModal(true);
      localStorage.removeItem('isOpenScheduleModal');
    }
  }, []);

  const handleCreate = async () => {
    await fetchData();
  };

  const eventTimeFormat = {
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: true
  };

  const renderEventContent = eventInfo => {
    console.log(eventInfo, eventInfo.view.type)

    return (
      <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
        {eventInfo.view.type !== "timeGridWeek" && <span>{eventInfo.timeText}</span>}
        {/* <span>{eventInfo.timeText}</span> */}
        <span>{' '} {eventInfo.event.title}</span>
      </div>
    );
  };

  const handleEventClick = info => {
    if (info.event.url) {
      window.open(info.event.url);
      info.jsEvent.preventDefault();
    } else {
      setModalEventContent(info);
      setIsOpenEventModal(true);
    }
  };

  const handleEventDrop = async info => {
    const updatedEvent = {
      id: info.event.id,
      start: info.event.startStr,
      end: info.event.endStr
    };
    await patchMeeting(info.event.id, updatedEvent);
    await fetchData();
  };

  const viewName = [
    'Day View',
    'Week View',
    'Month View'
    // 'List View',
    // 'Year View'
  ];

  const handleFilter = filter => {
    setCurrentFilter(filter);
    switch (filter) {
      case 'Month View':
        calendarApi.changeView('dayGridMonth');
        setTitle(calendarApi.getCurrentData().viewTitle);
        break;
      case 'Week View':
        calendarApi.changeView('timeGridWeek');
        setTitle(calendarApi.getCurrentData().viewTitle);
        break;
      case 'Day View':
        calendarApi.changeView('timeGridDay');
        setTitle(calendarApi.getCurrentData().viewTitle);
        break;
      case 'List View':
        calendarApi.changeView('listWeek');
        setTitle(calendarApi.getCurrentData().viewTitle);
        break;
      default:
        calendarApi.changeView('listYear');
        setTitle(calendarApi.getCurrentData().viewTitle);
    }
  };

  useEffect(() => {
    setCalendarApi(calendarRef.current.getApi());
  }, []);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center gx-0">
            <Col xs="auto" className="d-flex justify-content-end order-md-1">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="nextTooltip">Previous</Tooltip>}
              >
                <Button
                  variant="link"
                  className="icon-item icon-item-sm icon-item-hover shadow-none p-0 me-1 ms-md-2"
                  onClick={() => {
                    calendarApi.prev();
                    setTitle(calendarApi.getCurrentData().viewTitle);
                  }}
                >
                  <FontAwesomeIcon icon="arrow-left" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="previousTooltip">Next</Tooltip>}
              >
                <Button
                  variant="link"
                  className="icon-item icon-item-sm icon-item-hover shadow-none p-0 me-lg-2"
                  onClick={() => {
                    calendarApi.next();
                    setTitle(calendarApi.getCurrentData().viewTitle);
                  }}
                >
                  <FontAwesomeIcon icon="arrow-right" />
                </Button>
              </OverlayTrigger>
            </Col>
            <Col xs="auto" className="d-flex justify-content-end order-md-2">
              <h4 className="mb-0 fs-0 fs-sm-1 fs-lg-2">
                {title || `${calendarApi.currentDataManager?.data?.viewTitle}`}
              </h4>
            </Col>
            <Col xs md="auto" className="d-flex justify-content-end order-md-3">
              <Button
                size="sm"
                variant="falcon-primary"
                onClick={() => {
                  calendarApi.today();
                  setTitle(calendarApi.getCurrentData().viewTitle);
                }}
              >
                Today
              </Button>
            </Col>
            <Col md="auto" className="d-md-none">
              <hr />
            </Col>
            <Col xs="auto" className="d-flex order-md-0">
              <IconButton
                variant="primary"
                iconClassName="me-2"
                icon="plus"
                // transform="shrink-3"
                size="sm"
                onClick={() => {
                  setIsOpenScheduleModal(!isOpenScheduleModal);
                }}
              >
                Add Meeting
              </IconButton>
            </Col>
            <Col className="d-flex justify-content-end order-md-2">
              <DropdownFilter
                className="me-2"
                filters={viewName}
                currentFilter={currentFilter}
                handleFilter={handleFilter}
                icon="sort"
                right
              />
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="p-0">
          <FullCalendar
            ref={calendarRef}
            headerToolbar={false}
            initialView="timeGridWeek"
            firstDay={1}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin
            ]}
            themeSystem="bootstrap"
            dayMaxEvents={2}
            direction={isRTL ? 'rtl' : 'ltr'}
            height={800}
            stickyHeaderDates={false}
            editable
            selectable
            selectMirror
            select={info => {
              setIsOpenScheduleModal(true);
              setScheduleStartDate(info.start);
              setScheduleEndDate(info.end);
            }}
            eventTimeFormat={eventTimeFormat}
            eventClick={handleEventClick}
            events={meetings}
            eventContent={renderEventContent}
            eventDrop={handleEventDrop}
          />
        </Card.Body>
      </Card>

      {isOpenScheduleModal && (
        <AddMeetingModal
          isOpenScheduleModal={isOpenScheduleModal}
          setIsOpenScheduleModal={setIsOpenScheduleModal}
          initialEvents={meetings}
          setInitialEvents={setMeetings}
          scheduleStartDate={scheduleStartDate}
          scheduleEndDate={scheduleEndDate}
          setScheduleStartDate={setScheduleStartDate}
          setScheduleEndDate={setScheduleEndDate}
          handleSubmit={handleCreate}
          setShowRecurrence={() => {}}
        />
      )}
      {isOpenEventModal && (
        <EditMeetingModal
          isOpenScheduleModal={isOpenEventModal}
          setIsOpenScheduleModal={setIsOpenEventModal}
          modalEventContent={modalEventContent}
          handleSubmit={handleCreate}
        />
      )}
    </>
  );
};

export default Calendar;
